import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useVeiculoNavegacao = () => {
  const history = useHistory();
  const handleRowClick = useCallback(row => {
    history.push(`/pages/veiculos/detalhes/${row.id}`);
  }, [history]);
  const handleAdicionar = useCallback(() => {
    history.push('/pages/veiculos/criar');
  }, [history]);
  const handleEditar = useCallback(id => {
    history.push(`/pages/veiculos/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
